'use client';

import { LuClipboardCopy } from 'react-icons/lu';

import { useCopyToClipboard } from '@web/hooks';
import { InlineStyles } from '@web/types';

import { CheckIcon } from '../icons';

import { SecondaryButton } from './SecondaryButton';

type CopyToClipboardButtonProps = {
  value: string;
  ariaLabel?: string;
  copiedLabel?: string;
  size?: number;
  timeout?: number;
  iconStyles?: InlineStyles;
};

/**
 * * Mini secondary button that copies a value to the clipboard.
 *
 * * Uses the copy hook for clipboard behavior and toggles a success state
 * * briefly to confirm the action.
 */
export function CopyToClipboardButton({
  value,
  ariaLabel = 'Copy',
  copiedLabel = 'Copied!',
  size = 18,
  timeout = 2000,
  iconStyles = {},
}: CopyToClipboardButtonProps) {
  const { hasCopied, copy } = useCopyToClipboard({ value, timeout });
  const label = hasCopied ? copiedLabel : ariaLabel;

  return (
    <SecondaryButton
      ariaLabel={label}
      variant="mini"
      onClick={() => {
        void copy();
      }}
    >
      {hasCopied ? (
        <CheckIcon size={size} styles={iconStyles} />
      ) : (
        <LuClipboardCopy size={size} style={iconStyles} />
      )}
    </SecondaryButton>
  );
}
